<template>
    <page-loader v-if="loadingStatus == 'loading'" />
    <div v-else class="col-sm-12">
        <div class="container">
            <div class="card-section text-center mb-5 pb-5 book-wrap">
                <figure class="text-center">
                    <img :src="book && book.pdf_of_your_results_now_available && book.pdf_of_your_results_now_available.length > 0 ? book.pdf_of_your_results_now_available[0].image[0].url : ''"
                        class="img-fluid m-auto ml-inherit w-auto">
                </figure>
                <div v-if="loadingStatus === 'failed'">
                    <div v-if="errorMessage === 'not_found'">
                        <h5 class="text-center fw-bold fs-2">{{ book && book.pdf_of_your_results_now_available && book.pdf_of_your_results_now_available.length > 0 ? book.pdf_of_your_results_now_available[0].heading : '' }}</h5>
                        <p class="text-center mt-4" v-html="book && book.pdf_of_your_results_now_available && book.pdf_of_your_results_now_available.length > 0 ? book.pdf_of_your_results_now_available[0].text : ''"></p>
                        <div v-if="$store.getters.starterTestMode" class="mt-2">
                            <p class="text-center">You do not have a detailed autosomal breakdown currently. This means the PDF is not available. In order to purchase and download your personalised results book in PDF format please purchase your autosomal breakdown</p>
                            <router-link class="no-underline" :to="{ name: 'AncestryDetails', params: { slug: 'autosomal-upgrade' } }">
                                <button class="btn-primary view-store-btn m-auto mt-4">Upgrade now</button>
                            </router-link>
                        </div>
                        <div v-else class="mt-2">
                            <router-link class="no-underline" :to="{ name: 'HealthStore', query: { tab: 'merchandise' } }">
                                <button class="btn-primary view-store-btn m-auto mt-4">View in Store</button>
                            </router-link>
                        </div>
                    </div>
                    <div v-else>
                        <h5 class="text-center fw-bold fs-2"> We could not retrieve information about your book.</h5>
                    </div>
                </div>
                <div v-else>
                    <div v-if="bookDetails.status === 'pending'">
                        <h5 class="text-center fw-bold fs-2">PDF of your results now available</h5>
                        <p class="mt-4"> Your book PDF is being created, we'll email you once it's available to download </p>
                    </div>
                    <div v-else-if="bookDetails.status === 'completed'">
                        <h5 class="text-center fw-bold fs-2">Book ready to download</h5>
                        <p class="mt-4">
                            Your book for {{ $store.getters.profile.profile.name }}  has been created and is
                            available to download.
                        </p>
                        <p class="mt-4">
                            Use the options below to download the contents and cover for the book. If
                            you need to re-download the book in the future you can return to this page
                            and download the book.
                        </p>
                        <div class="mt-4 d-flex gap-4 flex-column flex-sm-row justify-content-center">
                            <BookPdfButton type="cover" @error="showError" @clear-error="clearError">
                                Download Cover
                            </BookPdfButton>
                            <BookPdfButton type="contents" @error="showError" @clear-error="clearError">
                                Download Contents
                            </BookPdfButton>
                        </div>
                        <p v-if="hasError" class="mt-4">
                            Sorry, we weren't able to download your file, for more assistance please
                            contact
                            <a href="mailto:help@livingdna.com" class="font-semibold">help@livingdna.com</a>.
                        </p>
                    </div>
                    <div v-else>
                        <p class="text-center mt-4">
                            Something has gone wrong with your book, please contact
                            <a href="mailto:help@livingdna.com"
                                class="font-semibold text-cobalt-500">help@livingdna.com</a>
                            for more assistance
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import '../../../styles/pages/ancentry/recent-ancetry.scss'
import { ref, onMounted } from "vue";
import { useLoading } from "@/composables/useLoading";
import { getRecentBook, getBookPdfDetails } from "@/services/ancestry";
import BookPdfButton from "@/components/ancestry/BookPdfButton.vue";
const { finishLoading, failLoading, loadingStatus, errorMessage } = useLoading();

const book = ref({});
const hasError = ref(false);
const bookDetails = ref({});

onMounted(async () => { book.value = await getRecentBook(); });

getBookPdfDetails()
    .then((res) => {
        bookDetails.value = res.data;
    })
    .then(finishLoading)
    .catch((err) => {
        if (err.response.status === 404) {
            failLoading("not_found");
        } else {
            failLoading();
        }
    });

function showError() {
    hasError.value = true;
}

function clearError() {
    hasError.value = false;
}
</script>
